import { FC } from 'react'
import Table2 from 'components/molecules/tables/Table2'

const RedemptionsModuleHeader: FC = () => {
  return (
    <Table2.HeadRow>
      <Table2.HeadCell name='date' sorting>
        Date
      </Table2.HeadCell>
      <Table2.HeadCell name='account'>
        Account
      </Table2.HeadCell>
      <Table2.HeadCell name='amount'>
        Amount
      </Table2.HeadCell>
    </Table2.HeadRow>
  )
}

export default RedemptionsModuleHeader
